import React from 'react';

function ChevronDownWhite() {
  const containerStyle = {
    position: 'absolute',
    right: '8%',
    bottom: '12%',
    zIndex: '10'
  };
  const pathStyle = {
    fill: '#fff'
  };
  const svgStyle = {
    display: 'block',
    margin: 'auto'
  };
  return (
    <span className="chevron-down-white" style={containerStyle}>
      <svg id="Layer_1"
           data-name="Layer 1"
           xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 1612 1035"
           width="18" height="18"
           style={svgStyle}>
        <title>chevron-down-white</title>
        <path style={pathStyle} className="cls-1" d="M1683,808,941,1549q-19,19-45,19t-45-19L109,808q-19-19-19-45.5T109,717L275,552q19-19,45-19t45,19l531,531,531-531q19-19,45-19t45,19l166,165q19,19,19,45.5T1683,808Z" transform="translate(-90 -533)"/>
      </svg>
    </span>
  );
}

export  default ChevronDownWhite;



/** WEBPACK FOOTER **
 ** ./src/components/icons/chevronDownWhite.js
 **/